export const EventSeverity = {
  INFORMATION: -10,
  DEBUG: 0,
  OK: 10,
  WARNING: 20,
  ERROR: 30,
  CRITICAL: 40,
} as const;

export type EventSeverityValue = typeof EventSeverity[keyof typeof EventSeverity];

export const SeverityGroups = {
  ALL_OK: [EventSeverity.INFORMATION, EventSeverity.DEBUG, EventSeverity.OK] as const,
  REGULAR_ERROR: [EventSeverity.WARNING, EventSeverity.ERROR] as const,
  CRITICAL_ERROR: [EventSeverity.CRITICAL] as const,
} as const;
